import { useSelector } from "react-redux"
import { RootState } from "Shared/store/rootState.interface"
import { Employee, User } from "@finway-group/shared/lib/models"

export const useLoggedInUserProfile = () => new User(useSelector(({ auth }: RootState) => auth.user))

export const useLoggedInEmployeeProfile = () => {
    const loggedInUserId = useLoggedInUserProfile()?.id

    // do not use useEmployeeById since that would not include the current admin user.
    return new Employee(useSelector(({ employees }: RootState) => employees.items).find((employee: any) => employee.id === loggedInUserId))
}
